import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2 } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import MyTextInput from '../../../components/inputs/MyTextInput';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

function CrearEditarMeta({ open, onClose, refresh, meta, isEditing }) {

    const validationSchema = Yup.object({
        clase: Yup.string().required('La class es obligatoria'),
        millas: Yup.number()
        .transform((value, originalValue) => {
        // Limpia el símbolo de $ y otros caracteres no numéricos
        if (typeof originalValue === 'string') {
            const cleaned = originalValue.replace(/[^0-9.,-]/g, '').replace(',', '.');
            return parseFloat(cleaned);
        }
        return value;
        })
        .typeError('Debe ser un número válido')
        .required('El número de millas es obligatorio')
        .test('no-negativos-ni-cero', function (value) {
            if (value < 0) {
            return this.createError({ message: 'No puede ser negativo' });
            }
            if (value === 0) {
            return this.createError({ message: 'No puede ser cero' });
            }
            return true;
        }),
        mpg: Yup.number()
        .transform((value, originalValue) => {
        // Limpia el símbolo de $ y otros caracteres no numéricos
        if (typeof originalValue === 'string') {
            const cleaned = originalValue.replace(/[^0-9.,-]/g, '').replace(',', '.');
            return parseFloat(cleaned);
        }
        return value;
        })
        .typeError('Debe ser un número válido')
        .required('El número de mpg es obligatorio')
        .test('no-negativos-ni-cero', function (value) {
            if (value < 0) {
            return this.createError({ message: 'No puede ser negativo' });
            }
            if (value === 0) {
            return this.createError({ message: 'No puede ser cero' });
            }
            return true;
        }),
        cruise_ctrl_percent: Yup.number()
        .transform((value, originalValue) => {
        // Limpia el símbolo de $ y otros caracteres no numéricos
        if (typeof originalValue === 'string') {
            const cleaned = originalValue.replace(/[^0-9.,-]/g, '').replace(',', '.');
            return parseFloat(cleaned);
        }
        return value;
        })
        .typeError('Debe ser un número válido')
        .required('El porcentaje de cruise ctrl es obligatorio')
        .test('no-negativos-ni-cero', function (value) {
            if (value < 0) {
            return this.createError({ message: 'No puede ser negativo' });
            }
            if (value === 0) {
            return this.createError({ message: 'No puede ser cero' });
            }
            return true;
        }),
        idle_percent: Yup.number()
        .transform((value, originalValue) => {
        // Limpia el símbolo de $ y otros caracteres no numéricos
        if (typeof originalValue === 'string') {
            const cleaned = originalValue.replace(/[^0-9.,-]/g, '').replace(',', '.');
            return parseFloat(cleaned);
        }
        return value;
        })
        .typeError('Debe ser un número válido')
        .required('El porcentaje de idle es obligatorio')
        .test('no-negativos-ni-cero', function (value) {
            if (value < 0) {
            return this.createError({ message: 'No puede ser negativo' });
            }
            if (value === 0) {
            return this.createError({ message: 'No puede ser cero' });
            }
            return true;
        }),
        top_gear_percent: Yup.number()
        .transform((value, originalValue) => {
        // Limpia el símbolo de $ y otros caracteres no numéricos
        if (typeof originalValue === 'string') {
            const cleaned = originalValue.replace(/[^0-9.,-]/g, '').replace(',', '.');
            return parseFloat(cleaned);
        }
        return value;
        })
        .typeError('Debe ser un número válido')
        .required('El porcentaje de top gear es obligatorio')
        .test('no-negativos-ni-cero', function (value) {
            if (value < 0) {
            return this.createError({ message: 'No puede ser negativo' });
            }
            if (value === 0) {
            return this.createError({ message: 'No puede ser cero' });
            }
            return true;
        })
    });

    const initialValues = {
        clase: meta?.class || '',
        millas: meta?.millas || '',
        mpg: meta?.mpg || '',
        cruise_ctrl_percent: meta?.cruise_ctrl_percent || '',
        idle_percent: meta?.idle_percent || '',
        top_gear_percent: meta?.top_gear_percent || ''
    };

    const handleSubmit = async (values) => {

        const payload = {
            clase: values.clase,
            millas: values.millas,
            mpg: values.mpg,
            cruise_ctrl_percent: values.cruise_ctrl_percent,
            idle_percent: values.idle_percent,
            top_gear_percent: values.top_gear_percent
        };

        try 
        {
            if (isEditing) 
            {
                let responseEditar = await myApi.put(`/cargasFuel/editarMeta/${meta.id}`, payload);

                if(responseEditar.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Meta editado',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseEditar.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseEditar.data.data || 'Ya existe una class con ese nombre.'
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al editar meta',
                            text: responseEditar.data.data || 'Ocurrió un error desconocido',
                        });
                    }

                    console.error('Error de API:', responseEditar.data);
                }
            } 
            else 
            {
                let responseCrear = await myApi.post('/cargasFuel/crearMeta', payload);

                if(responseCrear.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Meta creada',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseCrear.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseCrear.data.data || 'Ya existe una class con ese nombre.'
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al crear meta',
                            text: responseCrear.data.data || 'Ocurrió un error desconocido',
                        });
                    }

                    console.error('Error de API:', responseCrear.data);
                }
            }
            refresh();
            onClose();
        } 
        catch (error) 
        {
            console.error('Error saving goals:', error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{isEditing ? 'Editar Meta' : 'Crear Meta'}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleSubmit }) => {
                

                    return (
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={{xs: 12, sm: 2}}>
                                    <MyTextInput
                                        name="clase"
                                        label="CLASS"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 2 }}>
                                    <MyNumberInput
                                        name="millas"
                                        label="MILLAS"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 2 }}>
                                    <MyNumberInput
                                        name="mpg"
                                        label="MPG"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 2 }}>
                                    <MyNumberInput
                                        name="cruise_ctrl_percent"
                                        label="CRUISE CTRL %"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 2 }}>
                                    <MyNumberInput
                                        name="idle_percent"
                                        label="IDLE %"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 2 }}>
                                    <MyNumberInput
                                        name="top_gear_percent"
                                        label="TOP GEAR %"
                                    />
                                </Grid2>
                                <DialogActions style={{ justifyContent: 'flex-end' }}>
                                    <Button type="submit" variant="contained" color="primary">
                                        Guardar
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarMeta